//https://stackoverflow.com/questions/610406/javascript-equivalent-to-printf-string-format
if (!String.prototype.wiseFormat) {
    String.prototype.wiseFormat = function() {
        return this.replace(/{(\d+)}/g, (match, d) => typeof arguments[d] !== "undefined" ? arguments[d] : match);
    };
}
